import { useState, useCallback } from 'react';
import { useToast } from '../components/UI/ToastProvider';

interface UseCopyTextReturn {
  copied: boolean;
  copyText: (text: string) => Promise<void>;
}

export default function useCopyText(duration: number = 2000): UseCopyTextReturn {
  const [copied, setCopied] = useState(false);
  const { addToast } = useToast();

  const copyText = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      addToast('Copiado!', 'success', duration);
      
      setTimeout(() => {
        setCopied(false);
      }, duration);
    } catch (error) {
      console.error('Erro ao copiar texto:', error);
      addToast('Erro ao copiar', 'error', duration);
    }
  }, [addToast, duration]);

  return { copied, copyText };
}

